import React from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';
import Animated from 'react-native-reanimated';

interface ArcProgressBarProps {
  progress: number;
  max: number;
  size: number;
}

const ArcProgressBar: React.FC<ArcProgressBarProps> = ({
  progress = 2,
  max = 5,
  size = 200
}) => {
  const strokeWidth = size * 0.17;
  const AnimatedPath = Animated.createAnimatedComponent(Path);
  const { PI, cos, sin } = Math;
  const r = (size - strokeWidth) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const A = PI + PI * 0.48;
  const startAngle = PI + PI * 0.24;
  const endAngle = 2 * PI - PI * 0.24;
  const x1 = cx - r * cos(startAngle);
  const y1 = -r * sin(startAngle) + cy;
  const x2 = cx - r * cos(endAngle);
  const y2 = -r * sin(endAngle) + cy;
  const d = `M ${x1} ${y1} A ${r} ${r} 0 1 0 ${x2} ${y2}`;

  const circumference = r * A;
  const indicatorSize = A * r * ((max - progress) / max);
  const roundCornerOffset = indicatorSize * 0.03;
  const indicatorStrokeDashoffset =
    (indicatorSize + roundCornerOffset) * 0.9708;

  return (
    <Svg width={size} height={size} stroke='red' strokeWidth={20}>
      <Defs>
        <LinearGradient id='indicator' x1='0' y1='0' x2='100%' y2='0'>
          <Stop offset='0' stopColor='#FFE792' />
          <Stop offset='0.7' stopColor='#FB5C02' />
          <Stop offset='1' stopColor='#FB5C02' />
        </LinearGradient>
      </Defs>

      <Path
        d={d}
        strokeWidth={strokeWidth}
        stroke='#FAF6F5'
        opacity={1}
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
      <AnimatedPath
        strokeLinejoin='round'
        strokeLinecap='round'
        stroke='url(#indicator)'
        fill='none'
        strokeDasharray={`${circumference}, ${circumference}`}
        {...{ d, strokeDashoffset: -indicatorStrokeDashoffset, strokeWidth }}
      />
    </Svg>
  );
};

export default ArcProgressBar;
